import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManagementService } from '../../data-management/data-management.service';
import { Group, Vehicule } from 'src/app/model/data-managemnt';
import { Subscription } from 'rxjs';
import { Path } from 'src/app/model/historical';
import { HistoricalService } from '../historical.service';
import {ModalController, Platform, PopoverController} from '@ionic/angular';
import { DatePipe } from "@angular/common";
import * as L from 'leaflet';
import Icon = L.Icon;
import Marker = L.Marker;

import { IonPullUpFooterState } from 'ionic-pullup';
import { PathModalComponent } from './path-modal/path-modal.component';
import { HeaderService } from 'src/app/header/header.service';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { GeocodingService } from 'src/app/utils/leaflet/service/geocoding.service';
import { Map } from "leaflet";
import { GlobalService } from 'src/app/global.config';
import '../../../../assets/leaflet-play/dist/LeafletPlayback.js';
import { LoadingService } from 'src/app/utils/loading/loadingService';
import { TranslateService } from '@ngx-translate/core';
declare let P: any;

import { version } from '../../../global.config';
import {VideoService} from "../../realtime/video.service";
import {Router} from "@angular/router";
import {SigninService} from "../../../signin/signin.service";
import {TrackControleComponent} from "../../../utils/leaflet/track-controle/track-controle.component";

@Component({
  selector: 'app-path',
  templateUrl: './path.component.html',
  styleUrls: ['./path.component.scss'],
})
export class PathComponent implements OnInit {
  pathMap: Map;
  //groups: Group[];
  //selectedGroup: Group = new Group();
  //selectedVehicule: Vehicule | null;
  AllGroups: Subscription;
  PathArray = [];
  AllPaths: Subscription;
  paths: Path[] = [];
  pathClicked: Path;
  isResultLoaded = true;
  typicalPathName: string;
  showSpiderChart = false;
  showDetails = false;
  dataReturned: any;
  footerState: IonPullUpFooterState;
  backButtonSubscription: Subscription;
  @ViewChild(PathModalComponent, { static: false }) pathModalComponent: PathModalComponent;
  playback: any;
  loading: boolean;
  version: string;
  selectedPath: any = 0;
  playBackPath : any;

  constructor(
    public dataManagementService: DataManagementService,
    public mapService: MapService,
    private modalController: ModalController,
    private geocodingService: GeocodingService,
    public historicalService: HistoricalService,
    public videoService: VideoService,
    public signinService: SigninService,
    public router: Router,
    public popoverController: PopoverController,
    private headerService: HeaderService, private platform: Platform,
    private globalService: GlobalService,
    public loadingService: LoadingService,
    public translate: TranslateService, public datepipe: DatePipe
  ) {
    this.footerState = IonPullUpFooterState.Collapsed;
    this.headerService.selectedTab = "historical";
    this.historicalService.selectedTab = "path";
    this.version = version;
  }

  ngOnInit() {
    console.log(this.translate.currentLang)
    // this.dataManagementService.selectedGroup=this.dataManagementService.groups[0]
    // this.dataManagementService.selectedGroup.nom=this.dataManagementService.groups[0].nom
    // this.dataManagementService.selectedVehicule=this.dataManagementService.selectedGroup.vehicules[0]
    // this.dataManagementService.selectedVehicule.matricule=this.dataManagementService.selectedGroup.vehicules[0].matricule

    // if (this.dataManagementService.selectedVehicule) {

    //   this.historicalService.getAllPathRoutine();
    // }
    this.mapService.animatedMarker = null;
  }
  ngOnDestroy() {
    if (this.AllGroups) this.AllGroups.unsubscribe();
    if (this.AllPaths) this.AllPaths.unsubscribe();
  }

  ionViewWillEnter() {

    if (this.dataManagementService.selectedVehicule) {

      this.historicalService.getAllPathRoutine();
    }
  }

  ionViewDidEnter() {
    this.mapService.initMap(this.pathMap, "pathMap");
    this.mapService.animatedMarker = null;
  }
  ionViewWillLeave() {
    this.mapService.map.remove();
  }
  PathSelected(path: any) {
    return this.PathArray.indexOf(path as never) !== -1;
  }

  drawPath(path: Path) {
    if (
      this.pathClicked == null ||
      this.pathClicked.beginPathTime !== path.beginPathTime
    ) {
      this.pathClicked = new Path();
      this.pathClicked = path;
    }

    let maxSpeed = this.dataManagementService.selectedVehicule!.maxSpeed;
    if (this.playback) {
      this.playback.destroy();
    }

    this.historicalService
      .getPathDetails(this.dataManagementService.selectedVehicule!.idDevice, {
        startDate: path.beginPathTime,
        endDate: path.endPathTime
      })
      .subscribe(
        points => {
          this.playBackPath = points;
          // Open modal instead of navigation
          this.openTrackControlModal(this.playBackPath, 'path');
        },
        err => {
          console.error('Error loading path details:', err);
        }
      );
  }

  /**
   * Open track control modal instead of navigating to a new page
   */
  async openTrackControlModal(playBackPath: any, trackType: string) {
    const modal = await this.modalController.create({
      component: TrackControleComponent,
      componentProps: {
        trackData: playBackPath,
        trackType: trackType
      },
      cssClass: 'track-control-modal',
      backdropDismiss: true,
      showBackdrop: true
    });

    await modal.present();

    // Handle modal dismissal if needed
    const { data } = await modal.onWillDismiss();
    if (data) {
      console.log('Modal dismissed with data:', data);
      // Handle any data returned from the modal
    }
  }
  async openPopover() {
    const popover = await this.popoverController.create({
      component: PathModalComponent,
      cssClass: 'historiquePopovers'
    });

    await popover.present();
  }



  displayGoogleAdress(path: Path) {
    if (path) {
      this.geocodingService
        .inverseGeocondingGoogle(
          path.beginPathLatitude,
          path.beginPathLongitude
        )
        .subscribe(response => {
          if (response && response.results[0]) {
            path.beginPathGeocodingDetails =
              response.results[0].formatted_address;
          }
        });

      this.geocodingService
        .inverseGeocondingGoogle(path.endPathLatitude, path.endPathLongitude)
        .subscribe(response => {
          if (response && response.results[0]) {
            path.endPathGeocodingDetails =
              response.results[0].formatted_address;
          }
        });
    }
  }

  addPathToArray(path: any, event) {
    // console.log("this is path: ", path);
    if (!event.ctrlKey) {
      this.PathArray = [];
      // this.mapService?.removePolylinesFromMap();
      // this.mapService?.removeMarkersFromMap();
      if (this.playback) {
        this.playback.destroy();
      }
    }
   // console.log("this is path", path);
    this.PathArray.push(path);
    this.trackingPath(path);
    this.drawPath(path);
    // if (this.currentUser.username === 'wic') {
    //   this.getAllStops();
    //   this.mapService.getAllDriverStops(path.beginPathTime, path.endPathTime);
    // }
  }

  trackingPath(path: Path) {
    if (this.selectedPath != path) {
      this.selectedPath = path;
      if (this.showSpiderChart) {
        this.getSelectedPath(this.selectedPath.points);
      }
    }
  }

  getSelectedPath(points: any) {
    {
      try {
        var coordinates = points.coordinates
        var point = [];
        var times = [];

        for (var i = 0; i < coordinates.length; i++) {
          point[i] = [coordinates[i].lng, coordinates[i].lat];
          times[i] = coordinates[i].date;
        }

        var demoTracks = {
          "type": "Feature",
          "geometry": {
            "type": "MultiPoint",
            "coordinates": point
          },
          "properties": {
            "time": times
          }
        }

        // Playback options
        var playbackOptions = {
          playControl: true,
          dateControl: true,
          sliderControl: true,
          tracksLayer: true,
          staleTime: 2000,
          fadeMarkersWhenStale: true,
        };

        //Initialize playback
        this.playback = new P.Playback(this.mapService.map, demoTracks, null, playbackOptions);

      } catch (error) {

      }

    }
  }

  footerExpanded() {
    console.log('Footer expanded!');
  }

  footerCollapsed() {
    console.log('Footer collapsed!');
  }

  toggleFooter() {
    this.footerState = this.footerState === IonPullUpFooterState.Collapsed ? IonPullUpFooterState.Expanded : IonPullUpFooterState.Collapsed;
  }



  startAnimation() {
    this.mapService.simulation = true
    this.mapService.addMarker(this.mapService.animatedMarker)
    this.mapService.animatedMarker.start();
    this.mapService.animatedMarker.openPopup()
    this.mapService.replaySimulation = true
    //this.mapService.fitBounds(this.mapService.animatedMarker.getLatLng())
  }

  stopAnimation() {
    this.mapService.simulation = false
    this.mapService.animatedMarker.stop();
  }

  openCamPage(path: Path) {
    this.videoService.onConnectClick(this.dataManagementService.selectedVehicule)
    this.videoService.type = "playback";
    this.videoService.path = path;
    this.router.navigate(['camera']);
    }



}
